import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=90cfa6b6&lang=pug"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports